import React from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';

import { useScreenClass } from '@vp/swan';
import { Analytics } from './components/Analytics';
import { DevLandingPage } from './components/DevLandingPage';
import { UploadAndPrint } from './components/UploadAndPrint/UploadAndPrint';
import { LOCALIZED_ROUTES } from './constants';
import { currentCulture } from './utils/cultureUtil';

const localizedRoute = LOCALIZED_ROUTES[currentCulture.toLowerCase()];
export interface LayoutProps {
  children?: React.ReactNode;
}

const APP_BASE_PATH = process.env.REACT_APP_ROUTER_BASENAME || '';
const cb = (window as Window & typeof globalThis & { configureNewrelic?: (appId: string) => void }).configureNewrelic;
process.env.REACT_APP_NR_APP_ID && cb && cb(process.env.REACT_APP_NR_APP_ID);

const Router: React.FC = () => {
  const screenClass = useScreenClass();
  const isMobile = screenClass === 'xs';

  return (
    <>
      <Analytics />
      <BrowserRouter basename={APP_BASE_PATH}>
        <Routes>
          <Route path={localizedRoute}>
            <Route index element={<UploadAndPrint isMobile={isMobile} />} />
            {/* {embeddedChat} */}
          </Route>

          <Route
            path="/"
            element={
              process.env.NODE_ENV === 'development' ? (
                <DevLandingPage /> /* Wrap DevLandingPage in a Route component */
              ) : (
                <Navigate to={localizedRoute} />
              )
            }
          ></Route>
        </Routes>
      </BrowserRouter>
    </>
  );
};

export default Router;
